import React, { FC } from 'react';

import { NPC_FUNNEL_AUTOPAY_TWO_KEY } from 'src/commons/constants';
import { getOptimizelyVariation } from 'src/commons/utilities/feature-flags';

import { AutoPayHeading, AutoPaySubHeading } from './styles';

interface AutoPayHeaderProps {
  isConditional?: boolean;
  bankName?: string;
  maskedAccountNumber?: string;
}

export const AutoPayHeader: FC<AutoPayHeaderProps> = ({
  isConditional = false,
  bankName = null,
  maskedAccountNumber = null,
}) => {
  const autoPayConditionalFeature = getOptimizelyVariation(
    NPC_FUNNEL_AUTOPAY_TWO_KEY
  ).toLowerCase();

  const isVariantA = autoPayConditionalFeature === 'variant-a' && isConditional;
  // Variant B is the only option that is shown for the one step auto pay flow
  const isVariantB =
    autoPayConditionalFeature === 'variant-b' || !isConditional;
  const isControl = !isVariantA && !isVariantB;

  const getSubheaderText = (): string | null => {
    if (isVariantA) return null;
    if (isConditional) {
      return `Use ${bankName} Account ${maskedAccountNumber} for automatic payments and enjoy all the perks`;
    }

    return "Connect your bank for automatic payments. You'll enjoy all the perks:";
  };

  const headingText = isControl ? 'Set up AutoPay' : 'Save $59 with AutoPay';
  const subheadingText = getSubheaderText();

  return (
    <>
      <AutoPayHeading>{headingText}</AutoPayHeading>
      {subheadingText ? (
        <AutoPaySubHeading>{subheadingText}</AutoPaySubHeading>
      ) : null}
    </>
  );
};
